import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
  const decryptedData = CryptoJS.AES.decrypt(localStorage.getItem("token"), CRYPTO_TOKEN_SECRET_KEY).toString(CryptoJS.enc.Utf8);
  return decryptedData;
};

export const getTenantAction = async (currentPage, searchValue, pageSize, status, byUser) => {
  let apiUrl = `/api/tenant?page=${currentPage}&searchValue=${searchValue}&pageSize=${pageSize}&status=${status}`;
  if (byUser) {
    apiUrl += `&byUser=${byUser}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createTenantAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/tenant/create", data)
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error?.response?.data);
      });
  });
};

export const editTenantAction = async (data, id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tenant/update-tenant/${id}`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error?.response?.data);
      });
  });
};

export const changeBillingStatusAction = async (id, status) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tenant/changeBillingStatusAction/${id}`, status, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const getTenantDetailByIdAction = async (id) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/tenant/${id}`, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteTenantByIdAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/tenant/tenant-delete`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateTenantStatusAction = async (id, isActive) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const data = {
    isActive: isActive,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tenant/update-tenant-status/${id}`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteMultipleTenantByIdAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tenant/delete-multiple-tenant`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTenantSSOUrlAction = async (email) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/user/login-SSO", email)
      .then((response) => {
        if (response?.status === 200) {
          resolve(response?.data);
        } else {
          reject(new Error(response?.data?.data?.message || "Unexpected error occurred."));
        }
      })
      .catch((error) => {
        reject(new Error(error?.response?.data?.message || "Failed to fetch SSO URL."));
      });
  });
};

export const getCountriesDataAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/countries`)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const verifyDomainAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/tenant/verify-domain-url`, data)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateTenantAutopayAction = async (id, isAutoPay) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const data = {
    isAutoPay: isAutoPay,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tenant/update-tenant-autopay/${id}`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAllTenantAction = async (byUser) => {
  let apiUrl = `/api/tenant`;
  if (byUser) {
    apiUrl += `?byUser=${byUser}`;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTenantCurrenciesAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/tenant/get-tenant-currencies`)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editCurrencyRatesAction = async (data) => {
  const authToken = getAuthToken();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tenant/update-currency-rates`, data, {
        headers: headers,
      })
      .then((response) => {
        resolve(response?.data?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendEmailForBillingAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/tenant/sendEmailForBillingAction", id)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error?.response?.data);
      });
  });
};

//Q-Bot

export const makePlanPaymentLinkAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/tenant/payment`, data)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const makeRenewPlanPaymentAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/tenant/renewPlan`, data)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const renewTenantPlanAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/tenant/renew-plan`, data)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getAllTenantAllowedFeaturesAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/tenant/get-allowed-features`)
      .then((response) => {
        resolve(response?.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};